var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4861 2.04741C21.0105 1.53927 22.4608 2.98956 21.9527 4.51399L16.8961 19.6838C16.3624 21.2847 14.1852 21.498 13.351 20.031L10.3347 14.7264L13.3162 11.7448C13.6091 11.4519 13.6091 10.977 13.3162 10.6841C13.0233 10.3913 12.5485 10.3913 12.2556 10.6841L9.27408 13.6656L3.96907 10.6491C2.50213 9.81492 2.71539 7.63765 4.31631 7.10401L19.4861 2.04741Z",
    fill: "#1C1C20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.0ddf5ca3125c66642f2e26274cb89d92.svg";
export { ForwardRef as ReactComponent };